import { ApiResult } from "../models/ApiResult";
import { setInfoMessage, setWarningMessage } from "../store/alerts/alertsActions";

export const dispatchAlerts = (
  response: ApiResult,
  dispatch: Function = () => {}
) => {
  if (!response?.errorTable?.length) {
    return undefined;
  }

  let action;
  if (response.messageType === "info") {
    action = setInfoMessage(response.errorTable);
  } else if (response.messageType === "warning") {
    action = setWarningMessage(response.errorTable);
  }

  if (action) {
    dispatch(action);
  }

  return action;
};

export const onErroredResponse = (
  _errors: string[],
  _dispatch: Function = () => {}
) => {
  return undefined;
};
